import { Checkbox, InputNumber, Select } from "antd";
import React from "react";

import { IBaseProps } from "lib/data/interfaces";
import { MultipleItemRequirement } from "lib/data/model";
import { ComponentTemplate } from "lib/data/model";
import { DataFieldTemplate } from "lib/data/model";
import { Requiredness } from "lib/data/model/enumerations";
import { MultipleItemRequirementType } from "lib/data/model/enumerations/MultipleItemRequirementType";

import { RequirementItemSelector } from "../RequirementItemSelector";

interface IMultipleItemConfigurationProps extends IBaseProps {
	multipleItemRequirement?: MultipleItemRequirement<ComponentTemplate> | MultipleItemRequirement<DataFieldTemplate>;
	updateMultiItemRequirement(): void;
}

export class MultipleItemConfiguration extends React.Component<IMultipleItemConfigurationProps> {

	constructor(props: IMultipleItemConfigurationProps) {
		super(props);
		this.state = {

		};
	}

	public render() {
		if (!this.props.multipleItemRequirement) {
			return null;
		}
		return (
			<div className="multipleItemRequirement">
				<div className="template-card-checkboxes" onClick={(e) => e.stopPropagation()}>

					<Checkbox
						checked={this.props.multipleItemRequirement.requiredness === Requiredness.REQUIRED}
						onChange={this.changeRequiredness}
					>
						Required
					</Checkbox>

					<p>This section must implement:
						<Select onChange={this.changeRequirementType} value={MultipleItemRequirementType[this.props.multipleItemRequirement.requirementType]} style={{ width: 100 }}>
							{Object.keys(MultipleItemRequirementType).filter((item) => !isNaN(Number(item))).map((item, key) =>
								<Select.Option
									key={key}
									value={MultipleItemRequirementType[item]}
								>
									{MultipleItemRequirementType[item].toString()}
								</Select.Option>
							)}
						</Select>
						<InputNumber
							onChange={this.changeFulfillmentCount}
							value={this.props.multipleItemRequirement.fulfillmentCount}
							type="number"
							min={0}
							max={this.props.multipleItemRequirement.items.length}
							style={{ width: "5em" }}
						/>
						&nbsp;of the following
						</p>
					<RequirementItemSelector titleBarText="" requirementItemList={this.props.multipleItemRequirement.items} highlighted={true} />
				</div>
			</div>
		);
	}

	private changeRequiredness = () => {
		if (this.props.multipleItemRequirement) {
			if (this.props.multipleItemRequirement.requiredness === Requiredness.OPTIONAL) {
				this.props.multipleItemRequirement.requiredness = Requiredness.REQUIRED;
			} else {
				this.props.multipleItemRequirement.requiredness = Requiredness.OPTIONAL;
			}
		}
		this.props.updateMultiItemRequirement();
	}

	private changeRequirementType = (value: string) => {
		if (value) {

			if (this.props.multipleItemRequirement) {
				this.props.multipleItemRequirement.requirementType = MultipleItemRequirementType[value];
				this.props.updateMultiItemRequirement();
			}
		}
	}

	private changeFulfillmentCount = (value?: number) => {
		if (value) {

			if (this.props.multipleItemRequirement) {
				this.props.multipleItemRequirement.fulfillmentCount = value;
				this.props.updateMultiItemRequirement();
			}
		}
	}
}
